export default function convertTinyInt(value) {
  if (typeof value === 'boolean') {
    return value;
  }
  if (value === 1) {
    return true;
  }
  return false;
}
